import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Modal, Row } from "antd";
import React from "react";
import { camelCaseString } from "../../../../config/Global";

const ConfiremStartModal = (props) => {
  const { visible, close, CheckAction, loading } = props;
  const submit = () => {
    CheckAction(visible);
  };
  const keyValueArray = Object.entries(visible);
  return (
    <Modal
      centered
      className="addModal confirm"
      title={"Confirm Start Portability"}
      open={visible}
      closeIcon={<FontAwesomeIcon icon={faTimes} />}
      onCancel={close}
      footer={[
        <Button
          key="2"
          htmlType="button"
          className="cancelBtn"
          type="default"
          onClick={close}
        >
          Cancel
        </Button>,

        <Button key="1" type="default" onClick={submit} loading={loading}>
          Confirm
        </Button>,
      ]}
    >
      <Row gutter={[20, 0]} align={"top"} className="m-20">
        <Col xs={24}>
          <div>
            Are you sure want to start porting for:
            <div className="table-container">
              <table>
                <tbody>
                  {keyValueArray.map(([key, value]: any, index) => (
                    <tr key={index}>
                      <th>{camelCaseString(key)}</th>
                      <td data-label={camelCaseString(key)}>{value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Col>
        {/* <Col xs={24} md={12} lg={6}>
          <Button
            key="2"
            htmlType="button"
            className="cancelBtn"
            type="default"
            onClick={close}
          >
            Cancel
          </Button>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <Button key="1" type="default" onClick={submit} loading={loading}>
            Yes
          </Button>
        </Col> */}
      </Row>
    </Modal>
  );
};

export default ConfiremStartModal;
